import * as React from 'react';
import classnames from 'classnames';

import { styleOnlySanitizeGenericHtml } from 'utils/sanitize';

import './sov-callout-v2.scss';

type Props = {
  headerText: string,
  items?: Array<{ title?: string, body?: string }>,
  content: React.ReactNode,
  teaser?: React.ReactNode,
  button: React.ReactNode,
  className: string
};

class SOVCalloutV2 extends React.PureComponent<Props> {
  renderHeader(): React.ReactNode {
    const { headerText } = this.props;

    return (
      <div
        className="sov-callout-v2__header"
        dangerouslySetInnerHTML={{ __html: styleOnlySanitizeGenericHtml(headerText) }}
      />
    );
  }

  renderItems(): React.ReactNode {
    const { items } = this.props;

    return (
      <div className="sov-callout-v2__items">
        {
          items?.map(item => (
            <div
              key={`sov-callout-v2__item-section--${item.title}`}
              className="sov-callout-v2__item-section"
            >
              <div className="sov-callout-v2__item-title">
                {item.title}
              </div>
              <div className="sov-callout-v2__item-body">
                {item.body}
              </div>
            </div>
          ))
        }
      </div>
    );
  }

  renderButton(): React.ReactNode {
    const { button } = this.props;

    return (
      <div className="sov-callout-v2__button">
        {button}
      </div>
    );
  }

  renderContent(): React.ReactNode {
    const { content } = this.props;

    return (
      <div className="sov-callout-v2__content">
        {content}
      </div>
    );
  }

  render(): React.ReactNode {
    const { className, teaser, items } = this.props;
    const calloutClasses = classnames('sov-callout-v2', className);

    return (
      <div className={calloutClasses}>
        {this.renderHeader()}
        <div className="sov-callout-v2__body">
          {Boolean(items) && this.renderItems()}
          {teaser}
          {this.renderContent()}
          {this.renderButton()}
        </div>
      </div>
    );
  }
}

export default SOVCalloutV2;
